export const PXBanner = (function () {
	'use strict';

	var winH,
		startW,
		endW,
		widthDif,
		$arch,
		bannerOffsetTop,
		$banner;

	function init() {
		banner();
	}

	const banner = () => {
		console.log('Initialize PXBanner block');
		winH = $(window).height();
		startW = 1;
		endW = 2; 
		widthDif = endW - startW;
		$arch = $('.banner-arch');
		$banner = $('.pxblock--banner');
		
		if($banner.length != 0){
			bannerOffsetTop = $banner.offset().top;
		
			window.addEventListener('scroll', (ev) => {
				var distScrolled = $(document).scrollTop() - bannerOffsetTop;
				var percentScrolled = distScrolled / winH;
				percentScrolled = percentScrolled > 1 ? 1 : percentScrolled;
				percentScrolled = percentScrolled < 0 ? 0 : percentScrolled;
				var elW = (percentScrolled * widthDif) + startW;
				
				$arch.css('transform', 'scaleX('+elW+')');
			});	
	
			var $orangeText = $('.color-orange');
			$orangeText.addClass('animated');
		}
			
		
	}

	return {
		init: init,
		name: 'banner',
	};
})();
